// eslint-disable-next-line
import React, { useState, useEffect } from 'react'
import queryString from "query-string";
import { history } from "../../_redux/_store/history";
import { useDispatch, useSelector } from 'react-redux'
import { getAllRecommendationList } from '../../_redux/_actions/recommendationListActions' 
import FooterPagination from '../_footerpagination/FooterPagination'
import CreateRecommendation from '../recommendationWorkflow/CreateRecommendation.jsx'
import { CreateRecommendationSuccess } from '../recommendationWorkflow/CreateRecommendation.jsx'
import DeleteRecommendation from '../recommendationWorkflow/DeleteRecommendation.jsx'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import { Paper, Box, TableHead } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import Button from '@material-ui/core/Button'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ErrorHandler from '../updateHandlers/ErrorHandler'
import HelpBlockImg from '../../_assets/_images/helpBlock.png'
import Autocomplete from '@material-ui/lab/Autocomplete'
import EditRecommendation from './EditRecommendation'
import { SuccessDialog } from '../updateHandlers/MessageDialog'
import useDebounce from '../../utilities/useDebounce'
import SkeletonTableList from '../skeleton/SkeletonTableList.jsx'
import BreadcrumbDispatch from '../../_partials/breadcrumbDispatch';

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: 'white',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell)

const useStyles = makeStyles(() => ({
  Button: {
    width: '120px',
    marginRight: '20px',
    '&:hover': {
      background: '#52A1C2',
    },
  },
  helpIcon: {
    marginBottom: '-5px',
    marginLeft: '5px',
    width: '20px',
  },
  HelpBlockImg: {
    display: 'block',
    margin: 'auto',
    width: '100%',
    marginTop: '80px',
  },
  accordionButton: {
    '&:hover': {
      backgroundColor: 'white',
    },
    containerPaper: {
      height: '70%',
      padding: '30px',
      opacity: '1',
    },
    deleteFindingRuleTable: {
      marginTop: '2em',
    },
  },
  searchField: {
    marginTop: '-0.75em',
    marginRight: '20px',
  },
  containerPaper: {
    padding: '30px',
    height: '100%',
  },
  Pagination: {
    marginBottom: '30px',
    marginRight: '30px',
    marginTop: '30px',
  },
  deleteRuleTable: {
    maxHeight: 170,
  },
  recommendationInput: {
    width: '16em',
  },
}))

const Accordion = withStyles({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  },
  expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    marginBottom: -1,
  },
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails)

export default function SelectRecomendation() {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [currentPage, setcurrentPage] = useState(1)
  const [currentRule, setCurrentRule] = useState('')
  const [page, setPage] = useState(1)
  const [rulesPerPage] = useState(5)
  const [value, setValue] = useState(null)
  const [expanded, setExpanded] = useState(false)
  const dispatch = useDispatch()
  const debounce = useDebounce()
  const [allRecommendation, setAllRecommendation] = useState([])
  const [editRecommendation, setEditRecommendation] = useState(false)
  const recommendationResponse = useSelector((state) => state.recommendation)
  const [createRecommendationSuccess, setCreateRecommendationSuccess] =
    useState(false)
  const [createRecommendationFailure, setCreateRecommendationFailure] =
    useState(false)
  const [isUpdateSuccess, setIsUpdateSuccess] = useState(false)
  const [deleteConfirmationDialogOpen, setDeleteConfirmationDialogOpen] =
    useState(false)
  const [isDeleteSuccess, setDeleteSuccess] = useState(false)
  const [recommendationRuleToDelete, setRecommendationRuleToDelete] =
    useState('')
  const queryValues = queryString.parse(history.location.search)
  const {machine_type, hmi_type} = queryValues;

  useEffect(() => {
    if(!history.location.search)
    {
      history.push('/rules');
      return;
    }
    dispatch(getAllRecommendationList(machine_type, hmi_type))
  }, [])

  useEffect(() => {
    if (recommendationResponse.allRecommendation) {
      setAllRecommendation(
        recommendationResponse.allRecommendation.sort((a, b) => {
          return b.id - a.id
        })
      )
    }
  }, [recommendationResponse])

  const handleRecommendationChange = (newValue) => {
    setValue(newValue)
    if (newValue) {
      setAllRecommendation(
        recommendationResponse.allRecommendation.filter((recommendation) => {
          return (
            recommendation.id === newValue.id ||
            recommendation.description === newValue.description
          )
        })
      )
      setcurrentPage(1)
      setPage(1)
    } 
    else {
      setAllRecommendation(recommendationResponse.allRecommendation)
    }
  }

  // create recommendation dialog
  const handleCreateNewRecommendation = () => {
    setOpen(true)
  }

  //close create recommendation dialo
  const handleClose = () => {
    setOpen(false)
  }

  //controlled accordion
  const handleAccordionChange = (row) => (event, isExpanded) => {
    setExpanded(isExpanded ? row : false)
  }

  const handleEditDialog = (recommendation) => {
    if (recommendation) {
      setEditRecommendation(recommendation.id)
    } else {
      setEditRecommendation(false)
    }
  }

  const handleUpdateSuccess = (isTrue) => {
    if (isTrue) {
      setEditRecommendation(false)
      setIsUpdateSuccess(true)
      debounce(() => dispatch(getAllRecommendationList(machine_type, hmi_type)))
    } else {
      setIsUpdateSuccess(false)
      handleEditDialog()
      setEditRecommendation(false)
    }
  }

  useEffect(() => {
    const indexOfLastRule = currentPage * rulesPerPage
    const indexOfFirstRule = indexOfLastRule - rulesPerPage
    setCurrentRule(allRecommendation.slice(indexOfFirstRule, indexOfLastRule))
  }, [allRecommendation, currentPage])

  //setting current page
  const paginate = (pageNumber) => {
    setcurrentPage(pageNumber)
  }

  const handleChange = (event, value) => {
    setPage(value)
    paginate(value)
  }

  //fetch data of the recommendation rule to delete
  const handleDelete = (recommendationRuleId) => {
    setDeleteConfirmationDialogOpen(true)
    setRecommendationRuleToDelete(recommendationRuleId)
  }

  //deleting Finding Rule
  const handleCloseDeleteConfirmation = () => {
    setDeleteConfirmationDialogOpen(false)
  }

  // success dialog upon delete recommendation
  const handleDeleteSuccess = (isTrue) => {
    if (isTrue) {
      setDeleteConfirmationDialogOpen(false)
      setDeleteSuccess(true)
      debounce(() => dispatch(getAllRecommendationList(machine_type, hmi_type)))
    } else {
      setDeleteConfirmationDialogOpen(false)
      setDeleteSuccess(false)
    }
  }

  return (
    <Grid container spacing={4}>
      <BreadcrumbDispatch />
      <Grid item md={9}>
        <Paper className={classes.containerPaper}>
          <Grid
            item
            container
            direction='row'
            style={{ marginBottom: '1em' }}
            justifyContent='space-between'
          >
            <Grid container alignItems='flex-end'>
              <Grid item>
                <Typography
                  variant='h4'
                  style={{ color: '#52A1C2', fontSize: '1.5rem' }}
                >
                  Select Recommendations
                </Typography>
              </Grid>
              <Grid item>
                <Tooltip title='question'>
                  <HelpOutlineIcon className={classes.helpIcon} />
                </Tooltip>
              </Grid>
            </Grid>
            <Grid container alignItems='flex-end' justifyContent='flex-end'>
              <Grid item style={{ paddingRight: '10px' }}>
                <Autocomplete
                  className={classes.recommendationInput}
                  id='searchrecc_searchtext'
                  value={value}
                  options={allRecommendation}
                  getOptionLabel={(option) =>
                    option.description ? option.description : ''
                  }
                  onChange={(event, newValue) => {
                    handleRecommendationChange(newValue)
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label='Search Recommendations' />
                  )}
                />
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={() => handleCreateNewRecommendation()}
                >
                  {' '}
                  + CREATE NEW
                </Button>
              </Grid>
            </Grid>

            { (
              <div
                style={{
                  height: '550px',
                  marginTop: 30,
                  width: '100%',
                }}
              >
                <TableContainer>
                  <Table aria-label='custom pagination table'>
                    <TableHead>
                      <TableRow style={{ backgroundColor: 'grey' }}>
                        <StyledTableCell align='left'>
                          <Typography style={{ color: 'white' }}>ID</Typography>
                        </StyledTableCell>
                        <StyledTableCell align='left'>
                          <Typography style={{ color: 'white' }}>
                            Description
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell align='left'>
                          <Typography style={{ color: 'white' }}>
                            Effort
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell align='left'>
                          <Typography style={{ color: 'white' }}>
                            Role
                          </Typography>
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {recommendationResponse.loading && <SkeletonTableList count={4} />}
                      {currentRule ?
                        currentRule.map((row, index) => {
                          return (
                            <TableRow style={{ height: 10 }} key={row.id}>
                              <TableCell component='th' scope='row'>
                                {row.id}
                              </TableCell>
                              <TableCell align='left'>
                                <Accordion
                                  square
                                  elevation={0}
                                  expanded={expanded === row.id}
                                  onChange={handleAccordionChange(row.id)}
                                >
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls='panel1a-content'
                                    id='panel1'
                                  >
                                    <div style={{whiteSpace: "pre-wrap"}}>
                                    {row.description}
                                    </div>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <Grid container>
                                      <Grid>
                                        <Button
                                          className={classes.accordionButton}
                                          onClick={() => handleEditDialog(row)}
                                        >
                                          <EditIcon style={{ fill: 'grey' }} />
                                        </Button>
                                      </Grid>
                                      <Grid
                                        item
                                        style={{ marginLeft: '0.5em' }}
                                      >
                                        <Button
                                          className={classes.accordionButton}
                                          onClick={() => handleDelete(row.id)}
                                        >
                                          <DeleteIcon
                                            style={{ fill: 'grey' }}
                                          />
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </AccordionDetails>
                                </Accordion>
                              </TableCell>
                              <TableCell align='left'>{row.effort}</TableCell>
                              <TableCell align='left'>
                                {row.department}
                              </TableCell>
                            </TableRow>
                          )
                        }) : (null)}
                         {
                  !recommendationResponse.loading && currentRule.length==0?
                  <TableRow
                  style={{ height: 10 }}
                >
                  <TableCell colSpan={5}>
                   No data found
                  </TableCell>
                </TableRow>:null
                }
                    </TableBody>
                  </Table>
                  <FooterPagination
                    page={page}
                    handleChange={handleChange}
                    rulesPerPage={rulesPerPage}
                    totalRules={allRecommendation.length}
                    paginate={paginate}
                  />
                </TableContainer>
              </div>
            )}
          </Grid>
        </Paper>
      </Grid>
      <Grid item md={3} className='helpBlock'>
        <Paper className={classes.containerPaper}>
          <Box component='div' className='helpBlockTitle'>
            Help
          </Box>
          <br />
          <p>How to search and select a Recommendation</p>
          <br />
          <p>
            Step 1: Use the search box to type the keywords based on description
            of Recommendation you are looking for.
          </p>
          <br />
          <p>Step 2: Select the correct recommendation from the table.</p>
          <p>Step 3: Press Edit/ Delete to Edit/Delete the selection.</p>
          <br />
          <p>How to create a new recommendation</p>
          <p>Step 1: Click on create on the upper right corner of screen.</p>
          <p>Step 2: Enter the description for the recommendation.</p>
          <Box component='div'>
            <img
              src={HelpBlockImg}
              alt='HelpBlockImg'
              className={`img-fluid ${classes.HelpBlockImg}`}
            />
          </Box>
        </Paper>
      </Grid>

      {/* Rendering Create Recommendation Component */}
      {open && (
        <CreateRecommendation
          open={open}
          onClose={(e) => handleClose()}
        />
      )}

      {/* Rendering create recommendation success dialog */}
      {createRecommendationSuccess && (
        <CreateRecommendationSuccess
          open={createRecommendationSuccess}
          setCreateRecommendationSuccess={setCreateRecommendationSuccess}
        />
      )}

      {/* Error when create Recommendation fails */}
      {createRecommendationFailure && (
        <ErrorHandler message={recommendationResponse.error} />
      )}

      {/* Rendering delete Recommendation pop up*/}
      {deleteConfirmationDialogOpen && (
        <DeleteRecommendation
          recommendationRuleToDelete={recommendationRuleToDelete}
          open={deleteConfirmationDialogOpen}
          onClose={(e) => handleCloseDeleteConfirmation()}
          handleDeleteSuccess={handleDeleteSuccess}
        />
      )}
      {/* Rendering Delete recommendation success message */}
      {isDeleteSuccess && (
        <SuccessDialog
          isSuccess={isDeleteSuccess}
          message={'Recommendation deleted successfully'}
          handleSuccessDialog={handleDeleteSuccess}
        />
      )}

      {editRecommendation && (
        <EditRecommendation
          editRecommendation={editRecommendation}
          handleEditDialog={handleEditDialog}
          handleUpdateSuccess={handleUpdateSuccess}
        />
      )}
      {isUpdateSuccess && (
        <SuccessDialog
          isSuccess={isUpdateSuccess}
          message={'Recommendation updated successfully'}
          handleSuccessDialog={handleUpdateSuccess}
        />
      )}
    </Grid>
  )
}
